import React, { Component, Fragment } from 'react'
import moment from 'moment-timezone'
// eslint-disable-next-line
import { connect } from 'react-redux'

import { Breadcrumbs, Button, Div, H1, Header } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { userCanAccessOrgPlaybookReports, userCanEditPlaybooks } from 'utils/access'
import getDateRanges from './DateTimeBuilder'
import { pathOr, find, propEq } from 'ramda'

class PlaybookCategoryHeader extends Component {
  constructor(props) {
    super(props)

    moment.tz.setDefault(props.timeZone)

    this.state = {
      currentSelection: 'last_30_days'
    }
  }


  changeDateRange = ({ value }) => {
    const { changeDates, playbook, campaign } = this.props
    const campaignOrPlaybook = !!playbook ? playbook : campaign

    const specialCasedDay = (value === 'last_update') ? campaignOrPlaybook.updatedAt : campaignOrPlaybook.createdAt
    const dateValues = getDateRanges(value, specialCasedDay)

    this.setState({
      currentSelection: value
    }, changeDates(dateValues))
  }
  selectOptions = [{
    label: 'Last 30 Days',
    value: 'last_30_days'
  },
  {
    label: 'This Week',
    value: 'current_week'
  }, {
    label: 'Last Week',
    value: 'previous_week'
  }, {
    label: 'This Month',
    value: 'current_month'
  }, {
    label: 'Last Month',
    value: 'previous_month'
  }, {
    label: 'All Time',
    value: 'forever'
  }, {
    label: 'Since last update',
    value: 'last_update'
  }]

  render() {
    const { currentSelection } = this.state
    const { playbook, campaign } = this.props
    const canAccessTeammatePlaybooks = userCanAccessOrgPlaybookReports()
    const playbookOrCampaignName = playbook ? playbook.name : pathOr(null, ['title'], campaign)
    return (
      <Header className="playbooks-category-header playbooks-category-header--reports">
        <Div className="playbooks-category-header--content">
          { !!playbook &&
              <Breadcrumbs
                headings={[
                  {
                    title: 'Reports',
                    link: '/reports'
                  },
                  {
                    title: canAccessTeammatePlaybooks ? 'Email playbooks' : 'Sales sequences',
                    link: `/reports/${canAccessTeammatePlaybooks ? 'email-playbooks' : 'sales-sequences'}`
                  },
                  {
                    title: playbook.name,
                    link: '#',
                    isActive: true
                  }
                ]}
              />
          }
          <H1>{playbookOrCampaignName ? playbookOrCampaignName : 'Loading your report...'}</H1>
        </Div>
        <Div className="playbooks-category-header-controls">
          {!!playbook &&
            <Fragment>
              <Select
                className="playbooks-category-header-controls--select"
                value={find(propEq('value', currentSelection), this.selectOptions)}
                options={this.selectOptions}
                onChange={this.changeDateRange}
                isClearable={false}
              />
              {userCanEditPlaybooks() && playbook.reportType !== "ABANDONED_BOOK_A_MEETING" &&
                <Button href={`/playbooks/${playbook ? playbook.id : ''}/edit`} type={'primary'}>Edit Playbook</Button>
              }
            </Fragment>
          }
          {!!campaign &&
            <Select
              className="playbooks-category-header-controls--select"
              value={find(propEq('value', currentSelection), this.selectOptions)}
              options={this.selectOptions}
              onChange={this.changeDateRange}
              isClearable={false}
            />
          }
        </Div>
      </Header>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    timeZone: state.user.timeZone
  }
}

export default connect(mapStateToProps, null)(PlaybookCategoryHeader)
